import BlockModel from '@wre/infinity-generators/SchemeOfLearning/Year6/Spring/AreaPerimeterAndVolume/index';
import { newBlockContent } from '../../../Block';
import { newSmallStepContent } from '../../../SmallStep';

const Block = newBlockContent({
  block: 'AreaPerimeterAndVolume',
  field: 'Measurement',
  weeks: [9, 10],
  smallSteps: [
    // Step 1
    newSmallStepContent({
      ...BlockModel.smallSteps[0],
      module: () =>
        import(
          /* webpackChunkName: "Year6/Spring/AreaPerimeterAndVolume/1ShapesSameArea" */ './1ShapesSameArea'
        )
    }),
    // Step 2
    newSmallStepContent({
      ...BlockModel.smallSteps[1],
      module: () =>
        import(
          /* webpackChunkName: "Year6/Spring/AreaPerimeterAndVolume/2AreaAndPerimeter" */ './2AreaAndPerimeter'
        )
    }),
    // Step 3
    newSmallStepContent({
      ...BlockModel.smallSteps[2],
      module: () =>
        import(
          /* webpackChunkName: "Year6/Spring/AreaPerimeterAndVolume/3AreaOfATriangleCountingSquares" */ './3AreaOfATriangleCountingSquares'
        )
    }),
    // Step 4
    newSmallStepContent({
      ...BlockModel.smallSteps[3],
      module: () =>
        import(
          /* webpackChunkName: "Year6/Spring/AreaPerimeterAndVolume/4AreaOfARightAngledTriangle" */ './4AreaOfARightAngledTriangle'
        )
    }),
    // Step 5
    newSmallStepContent({
      ...BlockModel.smallSteps[4],
      module: () =>
        import(
          /* webpackChunkName: "Year6/Spring/AreaPerimeterAndVolume/5AreaOfAnyTriangle" */ './5AreaOfAnyTriangle'
        )
    }),
    // Step 6
    newSmallStepContent({
      ...BlockModel.smallSteps[5],
      module: () =>
        import(
          /* webpackChunkName: "Year6/Spring/AreaPerimeterAndVolume/6AreaOfAParallelogram" */ './6AreaOfAParallelogram'
        )
    }),
    // Step 7
    newSmallStepContent({
      ...BlockModel.smallSteps[6],
      module: () =>
        import(
          /* webpackChunkName: "Year6/Spring/AreaPerimeterAndVolume/7VolumeCountingCubes" */ './7VolumeCountingCubes'
        )
    }),
    // Step 8
    newSmallStepContent({
      ...BlockModel.smallSteps[7],
      module: () =>
        import(
          /* webpackChunkName: "Year6/Spring/AreaPerimeterAndVolume/8VolumeOfACuboid" */ './8VolumeOfACuboid'
        )
    })
  ]
});
export default Block;
